import React, { type PropsWithChildren } from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";

export const WarningIcon = ({
  resolutionOrder,
  level,
  children,
}: PropsWithChildren<{ resolutionOrder: any; level: string }>) => (
  <div className="flex items-center">
    <GenericTooltip
      noInfoCircle
      mouseEnterDelay={0.2}
      content={
        <>
          {level !== resolutionOrder[0].level && (
            <span className="text-gray+2 mr-0.5">Inherited:</span>
          )}
          Manually set at <b>{resolutionOrder[0].level}</b> level
        </>
      }
    >
      <div
        className={clsx(
          "flex items-center justify-center w-6 h-6 mr-2 text-[0.75rem]",
          "bg-sun-1 rounded-full",
        )}
      >
        <i className="fa-regular fa-sharp fa-warning text-[#996800] ml-[1px]"></i>
      </div>
    </GenericTooltip>
    {children}
  </div>
);
